<template>
  <div>
    <div class="results table-responsive container">
      <table class="table align-middle">
        <thead class="table-dark">
          <tr>
            <th>DATE</th>
            <th>RIDE</th>
            <th>DIST</th>
            <th>ELEV</th>
            <th>W <span>(avg)</span></th>
            <th>W/KG <span>(avg)</span></th>
            <th>HEART <span>(avg)</span></th>
            <th>TIME</th>
            <th class="btn-w">ANALYSIS</th>
            <!-- <th class="btn-w">COMPARE</th> -->
            <th class="btn-w">DOWNLOAD</th>
          </tr>
        </thead>
        <tbody class="table-light">
          <tr v-for="(item, index) in activities.results" :key="index">
            <td>
              {{ item.date | moment("DD/MM/YYYY") }}
              <span v-if="item.is_archived" class="archivedTag">Archived</span>
            </td>
            <td class="dblText">
              <div class="d-flex align-items-center">
                <div class="">
                  <img
                    style="width: 35px"
                    class="mx-2"
                    v-if="item.type === 'event' && item.sportType === 'cycling'"
                    src="/assets/images/activities/ActivityCal.png"
                  />
                  <img
                    style="width: 35px"
                    class="mx-2"
                    v-else-if="
                      item.type === 'ride' && item.sportType === 'cycling'
                    "
                    src="/assets/images/activities/ActivityCycle.png"
                  />
                  <img
                    style="width: 35px"
                    class="mx-2"
                    v-else-if="
                      item.type === 'workout' && item.sportType === 'cycling'
                    "
                    src="/assets/images/activities/ActivityBars.png"
                  />
                  <img
                    style="width: 35px"
                    class="mx-2"
                    v-else-if="
                      item.type === 'event' && item.sportType === 'running'
                    "
                    src="/assets/images/activities/ActivityType_run.png"
                  />
                  <img
                    style="width: 35px"
                    class="mx-2"
                    v-else-if="
                      item.type === 'ride' && item.sportType === 'running'
                    "
                    src="/assets/images/activities/ActivityType_run.png"
                  />
                  <img
                    style="width: 35px"
                    class="mx-2"
                    v-else-if="
                      item.type === 'workout' && item.sportType === 'running'
                    "
                    src="/assets/images/activities/ActivityType_run.png"
                  />
                </div>

                <div class="">
                  <strong>{{ item.title }}</strong>
                  <br />
                  {{ item.routeName }}
                </div>
              </div>
            </td>
            <td>{{ item?.distance.toFixed(2) }} KM</td>
            <td>{{ item?.elevation }} M</td>
            <td>{{ item.watt }} w</td>
            <td>{{ item.wattPerKg }} w/kg</td>
            <td>{{ item.heartrate }} bpm</td>
            <td>{{ item.rideDuration }}</td>
            <td>
              <button
                style="cursor: pointer"
                type="button"
                class="btnAnalysis"
                @click="$emit('view-activity', item.activityFileId, item.date)"
              ></button>
            </td>
            <td style="display: none">
              <input
                type="checkbox"
                v-model="localGraphFileIds"
                style="display: none"
                :value="item.activityFileId"
                class="input_class_checkbox"
              />
              <button
                style="cursor: pointer"
                type="button"
                class="btnCompare input_compare"
                :class="
                  localGraphFileIds.indexOf(item.activityFileId) !== -1
                    ? 'active'
                    : ''
                "
                @click="onAddToGraph($event, item.activityFileId)"
              ></button>
            </td>
            <td>
              <button
                style="cursor: pointer"
                type="button"
                class="btnDownload"
                @click="$emit('download-file', item.activityFileId)"
              ></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="contrLoadMore" v-if="!finished">
      <button
        v-if="showArchiveButton"
        type="button"
        class="ldmore"
        @click="$emit('show-archived')"
      >
        LOAD FROM ARCHIVE
      </button>
      <button v-else type="button" @click="$emit('load-more')" class="ldmore">
        LOAD MORE
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityList",
  props: {
    activities: {
      type: Object,
      required: true,
    },
    genders: {
      type: Array,
      required: true,
    },
    riderData: {
      type: Object,
      required: true,
    },
    graphFileIds: {
      type: Array,
      required: true,
    },
    finished: {
      type: Boolean,
      default: false,
    },
    showArchiveButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localGraphFileIds: [],
    };
  },
  created() {
    this.localGraphFileIds = [...this.graphFileIds];
  },
  watch: {
    graphFileIds(newVal) {
      this.localGraphFileIds = [...newVal];
    },
  },
  methods: {
    onAddToGraph(evt, fileId) {
      this.$emit("add-to-graph", evt, fileId);
    },
  },
  emits: [
    "view-activity",
    "download-file",
    "add-to-graph",
    "load-more",
    "show-archived",
  ],
};
</script>

<style scoped>
.archivedTag {
  display: block;
  width: fit-content;
  margin-top: 3px;
  padding: 0 6px;
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.05em;
  border: 1px solid #adb5bd;
  border-radius: 8px;
  color: #6c757d;
  text-transform: uppercase;
}
</style>
